import React from 'react'

import { Icon, mediaQueries, palette } from '@centivo/react-components'
import { NavLink } from 'react-router-dom'
import styled, { css } from 'styled-components'
import useMedia from 'use-media'

import { ExpandableMenu } from './ExpandableMenu'
import { MoreNavitem } from './MoreNavitem'

const activeItemStyles = css`
  color: ${palette.brand.teal};
  border-bottom-color: ${palette.brand.teal};
`

const List = styled.ul`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  list-style: none;
  padding: 0;
  flex-grow: 1;
`

const Item = styled.li`
  position: relative;
  font-size: 1rem;
  color: ${palette.neutral['grey-95989a']};
  height: 2rem;

  & > a {
    display: block;
    border-bottom: 2px solid transparent;
    line-height: 2rem;
  }

  &:hover:not(:last-child) > a,
  & :not(:last-child) > a:focus,
  & > a.active {
    ${activeItemStyles}
  }

  &:hover:last-child {
    color: ${palette.brand.teal};
  }

  &:not(:last-child) {
    margin-right: 2rem;
    cursor: pointer;
  }

  &:last-child {
    font-size: 1.5rem;
  }

  & > a,
  > btn,
  svg {
    color: inherit;
    &:hover {
      color: inherit;
    }

    &:focus {
      outline: none;
    }
  }

  & :not(svg, p) {
    font-size: inherit;
    text-decoration: none;
    line-height: 2rem;
    font-weight: 700;
  }
`

export const NavList: React.FC = () => {
  const isMobile = useMedia(mediaQueries.mobile)

  if (isMobile) {
    return <ExpandableMenu />
  }

  return (
    <List>
      <Item>
        <NavLink to="/member-search">Member Search</NavLink>
      </Item>
      <Item>
        <NavLink to="/referral-management">Referral Management</NavLink>
      </Item>
      <Item>
        <MoreNavitem />
      </Item>
      <Item>
        <NavLink to="/logout">
          <Icon icon="log-out" />
        </NavLink>
      </Item>
    </List>
  )
}
